import { render, staticRenderFns } from "./VideoSound.vue?vue&type=template&id=12cbb5ef&scoped=true"
import script from "./VideoSound.vue?vue&type=script&lang=js"
export * from "./VideoSound.vue?vue&type=script&lang=js"
import style0 from "./VideoSound.vue?vue&type=style&index=0&id=12cbb5ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cbb5ef",
  null
  
)

export default component.exports